export default __webpack_public_path__ + "static/media/starActive.e48f2def.svg";